import { all, put, takeLatest } from 'redux-saga/effects';
import store from '../../../../../store/store';

import MasterService from '../../../../../services/MasterService';
import { componentKey, setMasterAllergyList } from './MasterallergySlice';
import { addNotifications } from '../../../../../components/common-components/toaster/ToasterSlice';
import { TOASTER_VARIANT } from '../../../../../components/common-components/toaster/MetToaster';

export const { getMasterAllergy, createMasterAllergy, updateMasterAllergy, deleteMasterAllergy, bulkUploadMasterAllergy} = {
    getMasterAllergy: (payload) => {
        return {
            type: 'MASTER_ALLERGY/GET_MASTER_ALLERGY_LIST',
            payload,
        };
    },
    createMasterAllergy: (payload) => {
        return {
            type: 'MASTER_ALLERGY/CREATE_MASTER_ALLERGY',
            payload,
        };
    },
    updateMasterAllergy: (payload) => {
        return {
            type: 'MASTER_ALLERGY/UPDATE_MASTER_ALLERGY_LIST',
            payload,
        };
    },
    deleteMasterAllergy: (payload) => {
        return {
            type: 'MASTER_ALLERGY/DELETE_MASTER_ALLERGY_LIST',
            payload,    
        };    
    },
    bulkUploadMasterAllergy: (payload) => {
        return {
            type: 'MASTER_ALLERGY/BULK_UPLOAD_MASTER_ALLERGY',
            payload,
        };
    }
};

function* getMasterAllergyAsync(action) {
    try {
        const response = yield MasterService.getMasterAllergyList(action.payload);
        const {  status } = response.data; 
        if (status) {
            yield put(setMasterAllergyList(response.data));
        }
    } catch (error) {
        console.log('error', error);
        yield put(setMasterAllergyList([]));

    }
}


function* createMasterAllergyAsync(action) {
    try {
        const response = yield MasterService.createMasterAllergy(action.payload?.apiPayload);
        const {  status, message } = response.data;
        
        if (status) {
            yield put(addNotifications({ message: message || "Allergy created successfully", variant: TOASTER_VARIANT.SUCCESS }))
            action.payload?.closeEditModal();
            yield put(getMasterAllergy());
        }
    } catch (error) {
        yield put(addNotifications({ message: error?.data?.message || "Failed to create allergy", variant: TOASTER_VARIANT.ERROR }))
        console.log('error', error);
    }
}

function* updateMasterAllergyAsync(action) {
    try {
        const response = yield MasterService.updateMasterAllergy(action.payload?.id, action.payload?.apiPayload);
        const {  status, message } = response.data;
        
        if (status) {
            yield put(addNotifications({ message: message, variant: TOASTER_VARIANT.SUCCESS }))
            action.payload?.closeEditModal();
            yield put(getMasterAllergy());
        }
    } catch (error) {
        yield put(addNotifications({ message: error?.data?.message || "Something went wrong", variant: TOASTER_VARIANT.ERROR }))
        console.log('error', error);
        // yield put(setMasterAllergyList([]));

    }
}

function* bulkUploadMasterAllergyAsync(action) {
    try {
        const response = yield MasterService.bulkUploadMasterAllergy(action.payload?.fileData);
        const {  status, message, validationErrors } = response.data;
        
        if (status) {
            yield put(addNotifications({ message: message || "Bulk upload completed successfully", variant: TOASTER_VARIANT.SUCCESS }))
            action.payload?.closeEditModal();
            yield put(getMasterAllergy());
        } else if (validationErrors) {
            // Handle validation errors from API
            const errorMessage = Array.isArray(validationErrors) 
                ? validationErrors.join(', ') 
                : validationErrors;
            yield put(addNotifications({ message: errorMessage, variant: TOASTER_VARIANT.ERROR }))
        }
    } catch (error) {        
        yield put(addNotifications({ message: error?.response?.data?.message || "Bulk upload failed", variant: TOASTER_VARIANT.ERROR }))
        console.log('error', error);
    }
}

function* deleteMasterAllergyAsync(action) {
    try {
        const response = yield MasterService.deleteMasterAllergy(action.payload?.id);
        const {  status, message } = response.data;
        
        if (status) {
            yield put(addNotifications({ message: message, variant: TOASTER_VARIANT.SUCCESS }))
            action.payload?.setOpenDeleteModal();
            yield put(getMasterAllergy());
            // const deviceList = General.addLableValuePair(device, 'deviceName', 'uuid');
            // yield put((response.data));
        }
    } catch (error) {
        yield put(addNotifications({ message: error?.data?.message || "Something went wrong", variant: TOASTER_VARIANT.ERROR }))
        console.log('error', error);
        // yield put(setMasterAllergyList([]));

    }
}



function* rootSaga() {
    yield all([
        takeLatest(getMasterAllergy().type, getMasterAllergyAsync), 
        takeLatest(createMasterAllergy().type, createMasterAllergyAsync),
        takeLatest(updateMasterAllergy().type, updateMasterAllergyAsync) ,
        takeLatest(deleteMasterAllergy().type, deleteMasterAllergyAsync),
        takeLatest(bulkUploadMasterAllergy().type, bulkUploadMasterAllergyAsync)     
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
